import queryString from "query-string";

let queryParams = queryString.parse(window.location.search);

const B2BResize = (screen) => {
  // if (
  //   (document.referrer && document.referrer.indexOf("localhost") < 0) ||
  //   (window.parent && window.parent.location.origin)
  // ) {
  //   window.parent.postMessage(
  //     {
  //       action: "b2bresize",
  //       scrollHeight: document.body.clientHeight,
  //     },
  //     document.referrer || (window.parent && window.parent.location.href)
  //   );

  //   document.body.style.overflow = "auto";
  //   console.log(
  //     screen,
  //     `outer height: ${window.outerHeight}`,
  //     `client height: ${document.body.clientHeight}`
  //   );
  // }
  console.log("B2BResize called but not sending to parent");
};

const sendRedirToReferral = (referralData) => {
  const redirectURL = queryParams?.redir;
  if (
    !redirectURL ||
    redirectURL == "undefined" ||
    !referralData ||
    referralData == "undefined"
  ) {
    if (window?.parent?.location?.ancestorOrigins) {
        const parentDomain = window.parent.location.ancestorOrigins[0];
          window.top.location.href = parentDomain;
    }
  } else if (
    (redirectURL && redirectURL.indexOf("localhost") < 0) ||
    (window.top && window.top.location.origin)
  ) {
    window.top.location.href = `${referralData}?redir=${redirectURL}`;
  }
};

export { B2BResize, sendRedirToReferral };
